module.exports = __webpack_public_path__ + "img/電気回路_3_10_3.13efe38f.png";